import React, { useState, useContext, useEffect } from "react"
import moment from "moment"
import useLoading from "../../hooks/useLoading"
import { Button } from "../ui/button"
import { SvgWarning } from "../icons/"
import { SubscriptionRequests } from "../../api/app.service"
import { useAuthenticatedUser } from "../../hooks/useAuthenticatedUser"
import { useNavigate } from "react-router-dom"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

const SubscriptionEndingBanner = () => {
  const { user } = useContext(UserCtx)
  const navigate = useNavigate()
  const { startLoading, stopLoading } = useLoading()
  const [subscription, setSubscription] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(true)
  const authenticatedUser = useAuthenticatedUser(user)
  const { toast } = useToast()
  const getSubscription = async () => {
    startLoading()
    await SubscriptionRequests.getActiveSubscriptionCoach({
      user_id: parseInt(user.user_id),
    })
      .then((data: any) => {
        if (Object.keys(data.active_subscription).length !== 0) {
          setSubscription(data.active_subscription)
        } else {
          setSubscription(null)
        }
      })
      .catch((ex) => {
        console.error(ex)
        toast.error(ex.response.data.message)
      })
      .finally(() => {
        stopLoading()
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getSubscription()
  }, [])

  const isExpiringSoon =
    subscription?.subscription_end_date &&
    moment(subscription.subscription_end_date).isBetween(
      moment(),
      moment().add(30, "days"), 
      "day",
      "[]"
    )

  return (
    <>
      {authenticatedUser && user.activeProfile === "coach" && isExpiringSoon && subscription?.subscription_start_date === '11-26-2024' && (
        <section className="subscription-cta-gradient relative py-4 pr-4">
          <div className="hidden md:flex flex-col lg:flex-row items-center gap-4 lg:gap-32 justify-center w-full">
            {" "}
            <div className="flex items-center gap-4">
              <h1 className="flex items-center gap-2">
                <SvgWarning />
                If your subscription was purchased before <b>
                  Nov. 26, 2024
                </b>{" "}
                PayPal transition, it will not auto-renew. Please <b>renew</b>{" "}
                to continue enjoying benefits!
              </h1>
              <Button
                variant="black"
                onClick={() => navigate("/coach/subscription/plans")}
              >
                Renew
              </Button>
            </div>
          </div>
          <div className="lg:hidden flex flex-col lg:flex-row items-center gap-4 lg:gap-32 justify-center w-full ">
            {" "}
            <div className="flex items-center gap-2">
              <SvgWarning className="ml-4 h-10 w-10" />
              <span className="hidden md:block">
                If your subscription was purchased before <b>Nov. 26, 2024</b>{" "}
                PayPal transition, it will not auto-renew. Please <b>renew</b>{" "}
                to continue enjoying benefits!
              </span>

              {/* Text for xsm to sm screens */}
              <span className="block md:hidden">
                If your subscription was purchased pre-PayPal [Nov. 26, 2024],
                it will not auto-renew. Please <b>renew</b>.
              </span>
              <Button
                variant="black"
                onClick={() => navigate("/coach/subscription/plans")}
              >
                Renew
              </Button>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default SubscriptionEndingBanner
